import { toggleTheme } from "@/utils";
import { setUserConfig, setSystemConfig, getUserConfig, getSystemConfig } from '@/api/systemsettings'
import { homeconfig, systemStyle } from "@/config/systemsettings";
const state = {
    //系统风格设置
    systemStyle: null,
    //首页展示组件及布局，页面跳转不一定支持
    HomeConfig: [],
    layout: 'layout1', //布局方式
    theme: 'blue-theme', //主题(默认蓝色系)
    controlSize: 'mini', //element控件的大小
    //左侧导航栏
    navbar: {
        isOpen: true,
    },
    moduleConfig: [],
    pageSizes: [10, 20, 30, 50, 100],
    systemConfig: {},
    requestCount: 0,
    clientIp: '',
    message: [],
    messageShow: false,
}



const mutations = {
    //收缩左侧导航
    mToggleNavbar(state) {
        state.navbar.isOpen = !state.navbar.isOpen
    },
    //设置控件大小
    mSetControlSize(state, value) {
        state.controlSize = value
    },
    //设置主题
    mSetTheme(state, value) {
        state.theme = value
    },
    //设置请求次数
    mSetRequestCount(state, value) {
        state.requestCount = value
    },
    mSetClientIP(state, value) {
        state.clientIp = value
    },
}

const actions = {
    //收缩左侧导航
    aToggleNavbar({ commit }) {
        commit('mToggleNavbar')
    },
    //设置控件大小
    aSetControlSize({ commit }, type) {
        const sizeType = ['mini', ]
        commit('mSetControlSize', value)
    },
    //设置主题
    aSetTheme({ commit }, value) {
        commit('mSetTheme', value)
    },
    //设置请求次数
    aSetRequestCount({ commit }, value) {
        commit('mSetRequestCount', value)
    },
    aSetClientIP({ commit }, value) {
        commit('mSetClientIP', value)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js